import * as M from 'apollo-link-debounce'

// apollo-link-debounce is a CJS package; normalize default export across bundlers
export default ((M as any).default?.default ??
  (M as any).default ??
  M) as typeof M.default
